import React from 'react';
import { BarChart3, Zap, Scale, Plug, User, Target, Activity, Users, CreditCard } from 'lucide-react';

// Map the pack's lucide icon NAMES (ui.json predefined_goals) to components — professional
// symbols instead of emojis. Falls back to Target for unknown names. Same naming convention the
// dashboards.json icons use, so a new DB can just set "icon": "<lucide-name>".
const GOAL_ICON_MAP = {
  'bar-chart-3': BarChart3,
  zap: Zap,
  scale: Scale,
  plug: Plug,
  user: User,
  activity: Activity,
  users: Users,
  'credit-card': CreditCard,
};

export function GoalIcon({ name, ...props }) {
  const Icon = GOAL_ICON_MAP[name] || Target;
  return <Icon {...props} />;
}
